<template>
  <b-modal @hide="createModalClose" ref="createModal" :title="$t('棚番情報登録')" size="md">
    <b-container fluid>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-3 col-form-label">
          {{ $t("棚番名") }}
        </label>
        <div class="col-sm-9">
          <input type="text" class="form-control" placeholder="" v-model="create.form.name" />
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail3" class="col-sm-3 col-form-label">{{ $t("棚番コード") }}</label>
        <div class="col-sm-9">
          <input type="text" class="form-control" v-model="create.form.code" />
        </div>
      </div>
    </b-container>
    <template v-slot:modal-footer>
      <p class="text-danger text-center" v-if="create.error">{{ create.error }}</p>
      <div class="d-flex w-100 justify-content-center align-items-center mt-4 mb-4">
        <button
          type="button"
          class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
          @click="createRegistration()"
          :disabled="create.registration"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="create.registration"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          {{ $t("登録") }}
        </button>
        <button
          type="button"
          class="btn btn-light"
          @click="createModalClose()"
          v-if="!create.confirm"
          :disabled="create.registration"
        >{{ $t("キャンセル") }}</button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

const defaultCreate = {
  load: false,
  form: {
    code: null,
    name: '',
    key: 'box',
    options: {},
  },
  registration: false,
  error: '',
}

export default {
  data() {
    return {
      create: this.mixin_deepcopy(defaultCreate),
    }
  },
  methods: {
    createModalOpen(item) {
      const copy = this.mixin_deepcopy(item)
      if (copy.id) {
        // 稼働日をarrayに変換
        this.create.form = copy
      }
      this.$refs.createModal.show()
    },
    createModalClose() {
      this.create = this.mixin_deepcopy(defaultCreate)
      this.$refs.createModal.hide()
    },
    async createRegistration() {
      const pwd = this.create.form
      if (!pwd.name) {
        this.create.error = this.$t('棚番名') + this.$t('必須メッセージ')
        return
      }

      this.create.error = ''
      this.create.registration = true
      // 棚番情報登録のパラメーターを定義
      const params = {}

      let method = 'post'
      if (this.create.form.id) {
        method = 'put'
        params['id'] = this.create.form.id
      }
      params['code'] = this.create.form.code
      params['name'] = this.create.form.name
      params['key'] = this.create.form.key

      try {
        await this.$axios({
          method: method,
          url: `${this.$appConfig.CommonApiUrl}/space`,
          data: params,
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
        })
        this.$toasted.success(this.$t('データ登録完了メッセージ'))
        this.$emit('registed')
        this.createModalClose()
      } catch (err) {
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      } finally {
        this.create.registration = false
      }
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>
